/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { fetchTicketingData, fetchMyTickets } from "../../../store/thunks/ticketingPortalThunk";

/**
 * Custom hook to fetch data for the TicketingPortal landing screen.
 * Also pre-fetches My Tickets (pageSize=100) so the My Tickets screen does not
 * need to call the API again on initial navigation.
 */
const useTicketingPortalData = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { ticketingData, loading, error } = useSelector(
    (state: RootState) => state.ticketingPortal
  );
  const userEmail = useSelector((state: RootState) => state.appData?.userInfo?.email ?? "");

  useEffect(() => {
    // Fetch landing page data (KPIs, actions, etc.)
    dispatch(fetchTicketingData());
    // Pre-fetch My Tickets so the landing badge shows the real count and the
    // My Tickets screen can skip its own initial API call.
    dispatch(fetchMyTickets({
      pageSize: 100,
      pageNumber: 1,
      sortBy: "createdAt",
      sortOrder: "DESC",
      submitterEmail: userEmail || undefined,
    }));
  }, [dispatch, userEmail]);

  return {
    ticketingData,
    loading,
    error,
  };
};

export default useTicketingPortalData;
